var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"label":_vm.$t('addShooting.selectFormat'),"items":_vm.formatTypes},on:{"input":_vm.update},model:{value:(_vm.selectedFormat),callback:function ($$v) {_vm.selectedFormat=$$v},expression:"selectedFormat"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }